module.exports = __webpack_public_path__ + "img/GU.3ebe266c.png";